import { AutoMap } from "@automapper/classes";

export class MeanOfPreventionDTO {
    @AutoMap()
    name!: string;

}